import React, { useState } from 'react';
import { Camera, Eye, EyeOff } from 'lucide-react';
import { useApiHandler } from '../../utils/apiHandler';
import { useDispatch } from 'react-redux';
import { setRegToken,setAdmindata } from "../../Redux/Action/Authaction";
import { useNavigate } from 'react-router-dom';

function LoginPage() {
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        remember: false,
    });
    const apiHandler = useApiHandler();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();


        try {
            const response = await apiHandler.post("admin/login", { email: formData.email, password: formData.password }, { headers: { "Content-Type": "application/json" } });

            if (response.status === 200) {
                dispatch(setRegToken(response.data.accessToken));
                dispatch(setAdmindata(response.data?.admin));

                // On successful login
                navigate("/dashboard");
            } else {
                // Handle login failed
                console.error("Login failed");
            }
        } catch (error) {
            console.error("Error during login:", error);
        }
    };


    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    return (
        <div className="min-h-screen flex font-[Poppins]">
            {/* Left side - Hero Image */}
            <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-blue-900 to-blue-700 relative overflow-hidden">
                <div className="absolute inset-0 bg-black opacity-30"></div>

                <div className="absolute inset-0 flex flex-col justify-center px-12 text-white z-10 animate-fadeIn">
                    <h2 className="text-5xl font-bold mb-4 tracking-wide">
                        VVS
                    </h2>
                    <p className="text-xl mb-6 leading-relaxed opacity-90">
                        Advanced surveillance solutions powered by artificial intelligence.
                    </p>

                </div>
            </div>

            {/* Right side - Login Form */}
            <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-gray-50">
                <div className="w-full max-w-md space-y-6">
                    <div className="text-center">
                        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-4">
                            <Camera className="w-8 h-8 text-blue-600 animate-bounce" />
                        </div>
                        <h1 className="text-4xl font-bold text-gray-900 mb-2 tracking-wide">
                            Welcome <span className="text-blue-600">Back</span>
                        </h1>
                        <p className="text-gray-600 opacity-80">Sign in to access your dashboard</p>
                    </div>

                    <form
                        onSubmit={handleSubmit}
                        className="space-y-6 bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300"
                    >
                        {/* Email Input */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Email Address
                            </label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                                placeholder="you@example.com"
                            />
                        </div>

                        {/* Password Input */}
                        <div className="relative">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Password
                            </label>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                required
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                                placeholder="Enter your password"
                            />
                            <button
                                type="button"
                                className="absolute right-3 top-9 text-gray-400 hover:text-gray-600 transition-colors"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                            </button>
                        </div>

                        {/* Remember Me & Forgot Password */}
                        <div className="flex items-center justify-between">
                            <label className="flex items-center text-sm text-gray-600">
                                <input
                                    type="checkbox"
                                    name="remember"
                                    checked={formData.remember}
                                    onChange={handleChange}
                                    className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                                />
                                <span className="ml-2">Remember me</span>
                            </label>
                            <a href="#" className="text-sm text-blue-600 hover:text-blue-500">
                                Forgot password?
                            </a>
                        </div>

                        {/* Submit Button */}
                        <button
                            type="submit"
                            className="w-full px-4 py-2 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg font-medium shadow-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-transform duration-300 transform hover:-translate-y-1"
                        >
                            Sign In
                        </button>


                    </form>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;
